<template>
    <div id="app">
        <router-view />
        <Loading id="appLoading" :is-show="$store.state.isAppLoad" />
        <Concent
            v-if="
                this.$route.name != 'consent' &&
                this.$route.name != 'terms' &&
                this.$route.name != 'sso' &&
                this.$route.name != 'otpSso' &&
                this.$route.name != 'register' &&
                this.$route.name != 'linelogin' &&
                this.$route.name != 'reconsent' &&
                this.$route.name != 'maintenance'
            "
        />
    </div>
</template>

<script>
import Loading from "@/components/Layout/TopBar/Loading";
import Concent from "./components/Concent/Concent.vue";
import CacheHelper from "@/helper/CacheHelper.js";
export default {
    components: {
        Loading,
        Concent,
    },
    data: function () {
        return {
            cacheHelper: new CacheHelper(),
        };
    },
    created() {
        if (!this.cacheHelper.getCache("250325671052")) {
            const cookies = document.cookie.split(";");
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i];
                const eqPos = cookie.indexOf("=");
                const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                document.cookie =
                    name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
            localStorage.clear();
            sessionStorage.clear();
            this.cacheHelper.setCache("250325671052", "250325671052");
        }
    },
    mounted() {},
    methods: {},
};
</script>
<style lang="scss">
@import "@/style/main.scss";
</style>
